export default __webpack_public_path__ + "static/media/logo-color-on-black.75f71cce.svg";